module.exports = __webpack_public_path__ + "static/media/image-4.366257f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/UX/image-4.png
// module id = 451
// module chunks = 0